import { StyledSelect } from "../common.style";
import { Option } from "../../primitives";
import { CARDTRADER_SELLER_COUNTRY_CODE } from "magic-shared-types";

interface CountryDropdownProps {
  country: string;
  setCountry: (arg1: string) => void;
}

export const CountryDropdown = ({
  setCountry,
  country,
}: CountryDropdownProps) => {
  return (
    <StyledSelect value={country} onChange={(e) => setCountry(e.target.value)}>
      <Option value="">All Country</Option>
      {CARDTRADER_SELLER_COUNTRY_CODE.map((ct) => (
        <Option value={ct.value}>{ct.name}</Option>
      ))}
    </StyledSelect>
  );
};
